import { useState } from "react";
import { ORDER_TYPES } from "../../consts/api";

var unwrap = (value) => (Object.values(value).every(Boolean) ? value : null);

export function useEntityOrderState({ by, direction } = {}) {
  var { 0: value, 1: setValue } = useState({
    by: by || "",
    direction: direction || "",
  });

  var update = (key) => {
    setValue({
      by: key,
      direction:
        value.direction === ORDER_TYPES.desc
          ? ORDER_TYPES.asc
          : ORDER_TYPES.desc,
    });
  };

  return {
    value,
    update,
    unwrap: () => unwrap(value),
  };
}
